import { Component, OnInit } from '@angular/core'; 
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';

@Component({
  selector: 'app-our-features-first',
  templateUrl: './our-features-first.component.html',
  styleUrls: ['./our-features-first.component.scss']
})
export class OurFeaturesFirstComponent implements OnInit {

  ending: any = { end: -2, title: '' };
  userType: any;

  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    const { userType } = this.local.getUser();
    this.userType = userType;
    this.vip_token_transactions();
  }



  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe((response: any) => {
      this.ending = response.body.ending;
      if (this.ending.end == -1 && this.userType != "Admin") {
        window.location.href = '/#/new-dashboard/';
      }
    }, (error) => {
      if (error.status == 401) {
        //
      }
    });
  }

}
